export enum VerifiedBadgeType {
  VERIFIED = 'verified-v3.svg',
  PARTIALLY_VERIFIED = 'partially-verified-v3.svg',
}
